import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type FilterProps = Partial<SVGIconProps>;
const Filter = (props: FilterProps) => {
  return (
    <SVGIcon viewBox="0 0 18 22" {...props}>
      <path
        d="M16.7695 7.32624C16.7695 8.97193 13.1878 10.306 8.76953 10.306C4.35125 10.306 0.769531 8.97193 0.769531 7.32624M16.7695 7.32624C16.7695 11.0778 14.7014 14.2897 11.7695 15.6158V18.0176C11.7695 18.7701 11.3415 19.458 10.664 19.7945L8.66396 20.7877C7.33416 21.4481 5.76953 20.4877 5.76953 19.0109V15.6158C2.8377 14.2897 0.769531 11.0778 0.769531 7.32624M16.7695 7.32624C16.7695 6.38522 15.5985 5.54609 13.7695 5M0.769531 7.32624C0.769531 6.38522 1.94061 5.54609 3.76953 5M10.7695 4V6M6.76953 6V7M6.76953 1V3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SVGIcon>
  );
};

export default Filter;
